<template>
  <div class="index profile container w-full">
    <div class="columns">
      <aside class="column is-3 profile-aside">
        <span v-if="isPremium" class="premium-badge z-50"><img
            src="@/assets/img/badge.svg"
            alt=""
            srcset=""
          ></span>
        <span
          class="professional-avatar scale-hover"
          :style="{backgroundImage: `url('${activeProfile.profilePictureUrl || `https://ui-avatars.com/api/?size=512&background=386B61&color=fff&name=${activeProfile.name}+${activeProfile.lastName}`} ')` }"
        />
        <a
          href="#"
          @click="handleFavorite"
        >
          <b-icon
            v-if="!isFavorite"
            icon="star-outline"
          />
          <b-icon
            v-else
            icon="star"
          />
        </a>

        <h2 class="profile-name">
          {{ activeProfile.name }} {{ activeProfile.lastName }}
        </h2>
        <h3 class="profile-professional-title">
          {{ activeProfile.title }}
        </h3>
        <h2 class="profile-specialities">
          Especialidades
        </h2>
        <div class="tags-wrapper">
          <span
            v-for="(specialty, indx) in activeProfile.specialties"
            :key="indx"
            class="tag-light scale-hover"
          >
            <span class="tag-text">{{specialty}}</span>
          </span>
        </div>
        <h2 class="profile-treatment">
          Atendimento
        </h2>
        <div
          v-if="activeProfile"
          class="tags-wrapper"
        >
          <span
            v-if="activeProfile.services && activeProfile.services.online"
            class="tag-light scale-hover"
          >Online</span>
          <span
            v-if="activeProfile.services && activeProfile.services.inPerson"
            class="tag-light scale-hover"
          >Presencial</span>
        </div>
        <div v-if="activeProfile.insurances.length > 0">
          <h2 class="profile-treatment text-center">
            Convênios
          </h2>
          <div>
            <span
              v-for="(insurance, i) in activeProfile.insurances"
              :key="i"
            >{{insurance}} <br/></span>
          </div>
        </div>
        <div v-if="activeProfile.discount" style="max-width: 80%">
          <h2 class="profile-treatment text-center">
            Desconto para usuários do Psyservice
          </h2>
          <div>
           {{activeProfile.discount}}%
          </div>
        </div>
        <h2 class="profile-contact">
          Contato
        </h2>
        <div v-if="activeProfile">
          <span
            class="profile-contact-email"
            v-if="activeProfile.email"
          >
            <b-icon
                icon="email"
                size="is-small">
            </b-icon>
            {{ activeProfile.email }}
          </span><br>
          <span
            class="profile-contact-phone"
            v-if="activeProfile.phoneNumber1"
          >
            <b-icon
                icon="whatsapp"
                size="is-small">
            </b-icon>
            {{ activeProfile.phoneNumber1 }}
          </span><br>
          <span
            class="profile-contact-phone"
            v-if="activeProfile.phoneNumber2"
          >
            <b-icon
                icon="phone"
                size="is-small">
            </b-icon>
            {{ activeProfile.phoneNumber2 }}
          </span>
        </div>
        <h2 class="profile-adress">
          Endereço
        </h2>
        <span
          v-if="activeProfile.address.street"
          class="profile-address-line-1"
        >
          {{activeProfile.address.street}}
          {{activeProfile.address.number ? ` - ${activeProfile.address.number}`: ``}}
        </span>
        <span v-if="activeProfile.address.comp">
          {{activeProfile.address.comp}}
        </span>
        <span
          v-if="activeProfile.address.neighborhood"
          class="profile-address-line-2"
        >{{activeProfile.address.neighborhood}}</span>
        <span
          v-if="activeProfile.address.city && activeProfile.address.state"
          class="profile-address-city-state"
        >{{activeProfile.address.city}} - {{activeProfile.address.state}}</span>
        <h2 class="profile-social-networks" v-if="activeProfile.socialNetworks.length">
          Redes Sociais
        </h2>
        <span class="profile-social-links flex my-4">
          <a
            v-if="activeProfile.socialNetworks.instagram"
            :href="activeProfile.socialNetworks.instagram"
            class="flex-1 mx-4"
            target="_blank"
            rel="noopener"
          >
            <b-icon
              icon="instagram"
              size="is-medium"
            />
          </a>

          <a
            v-if="activeProfile.socialNetworks.twitter"
            :href="activeProfile.socialNetworks.twitter"
            class="flex-1 mx-4"
            target="_blank"
            rel="noopener"
          >
            <b-icon
              icon="twitter"
              size="is-medium"
            />
          </a>
          <a
            v-if="activeProfile.socialNetworks.facebook"
            :href="activeProfile.socialNetworks.facebook"
            class="flex-1 mx-4"
            target="_blank"
            rel="noopener"
          >
            <b-icon
              icon="facebook"
              size="is-medium"
            />
          </a>
          <a
            v-if="activeProfile.socialNetworks.linkedin"
            :href="activeProfile.socialNetworks.linkedin"
            class="flex-1 mx-4"
            target="_blank"
            rel="noopener"
          >
            <b-icon
              icon="linkedin"
              size="is-medium"
            />
          </a>
        </span>
        <div class="profile-action-buttons">
          <b-button
            type="is-primary"
            expanded
            outlined
            :icon-right="isFavorite ? 'star':'star-outline'"
            class="action-button"
            @click="handleFavorite"
          >
            {{ isFavorite ? 'Favoritado':'Favoritar' }}
          </b-button>
          <b-dropdown
            aria-role="menu"
            trap-focus
            :mobile-modal="false"
            position="is-bottom-left"
          >
            <b-button
              type="is-primary"
              expanded
              slot="trigger"
              role="button"
              icon-right="share-variant"
              class="action-button"
            >
              Compartilhar
            </b-button>
            <b-dropdown-item
              :focusable="false"
              custom
              paddingless
            >
              <social-sharing
                :url="$route.query.page"
                inline-template>
                <div class="flex justify-around">
                  <network network="twitter">
                    <a href="#">
                      <b-icon icon="twitter" /></a>
                  </network>
                  <network network="facebook">
                    <a href="#">
                      <b-icon icon="facebook" /></a>
                  </network>
                  <network network="linkedin">
                    <a href="#">
                      <b-icon icon="linkedin" /></a>
                  </network>
                </div>
              </social-sharing>
            </b-dropdown-item>

          </b-dropdown>

        </div>
      </aside>
      <main
        id="about"
        class="column is-9 profile-main"
      >
        <!-- Info Profile -->
        <section
          v-if="activeProfile"
          class="info-profile"
        >
          <span class="section-title">
            <h1 class="text-center md:text-left">{{ activeProfile.name }} {{ activeProfile.lastName}}</h1>
          </span>
          <p
            class="info-profile-text"
            v-if="activeProfile.biography"
          >{{ activeProfile.biography }}
          </p>
          <h3 v-else>Este usuário ainda não escreveu uma biografia</h3>
        </section>
        <!-- Blog Section -->
        <section class="content-section blog-posts">
          <span class="section-title">
            <h1 class="text-center md:text-left">Publicações</h1>
          </span>
          <!-- Blog Posts -->
          <BlogPosts
            :show-author="false"
            classes="column is-one-third-widescreen"
            :authorId="authorId"
          />
        </section>

        <!-- Nearby Professionals -->
        <ProfessionalsCarousel
          title="Profissionais Próximos"
          :breakpoints="breakpoints"
          queryType="professionalId"
          :professionalId="authorId"
        />
      </main>
    </div>
  </div>
</template>
<script>
import BlogPosts from '@/components/BlogPosts'
import ProfessionalsCarousel from '@/components/ProfessionalsCarousel/ProfessionalsCarousel'
import { professionalsGeoCollection } from '../firebaseConfig'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    BlogPosts,
    ProfessionalsCarousel
  },
  data () {
    return {
      activeProfile: {},
      isPremium: null,
      isFavorite: false,
      cols: {
        fullhd: 4,
        desktop: 6,
        tablet: 6
      },
      breakpoints: {
        375: {
          itemsToShow: 1
        },
        425: {
          itemsToShow: 2
        },
        1440: {
          itemsToShow: 3
        }
      },
      authorId: this.$route.params.id
    }
  },
  computed: {
    ...mapState(['currentUser', 'currentUserFavorites']),
    ...mapActions(['getPremiumStatusFromUser'])
  },
  methods: {
    async getProfile (id) {
      try {
        const profile = await professionalsGeoCollection
          .doc(id)
          .get()

        this.activeProfile = await profile.data()

        if (this.activeProfile && this.activeProfile.insurances) {
          const insurances = this.activeProfile.insurances
          this.activeProfile.insurances = insurances.filter(insurance => insurance !== '')
        }
      } catch (error) {
        console.error(error)
      }
    },

    checkIfProfileIsInFavorites () {
      this.isFavorite = this.currentUserFavorites.some(favorite => {
        return favorite.userId === this.activeProfile.userId
      })
    },

    async addToFavorites () {
      const {
        userId,
        name,
        lastName,
        title,
        profilePictureUrl,
        address
      } = this.activeProfile

      try {
        await this.$store.dispatch('addProfessionalToFavorites', {
          userId,
          name,
          lastName,
          title,
          profilePictureUrl,
          address
        })

        this.$toasted.success('Profisional adicionado à sua lista de favoritos')
      } catch (error) {
        this.$toasted.error('Não foi possível favoritar esse profissional. Tente novamente mais tarde')
      }
    },

    async removeFromFavorites () {
      try {
        const { userId } = this.activeProfile

        await this.$store.dispatch('removeProfessionalFromFavorites', userId)
        this.$toasted.success('Profissional removido da sua lista de favoritos')
      } catch (error) {
        this.$toasted.error('Não foi possível remover esse profissional. Tente novamente mais tarde')
      }
    },

    async handleFavorite () {
      if (!(this.currentUser && this.currentUser.uid)) {
        this.$toasted.error('Você precisa estar logado para adicionar um profissional aos favoritos')
        return
      }
      this.isFavorite ? this.removeFromFavorites() : this.addToFavorites()
    }
  },
  watch: {
    async '$route' () {
      await this.getProfile(this.$route.params.id)

      if (this.currentUser && this.currentUser.uid) {
        this.checkIfProfileIsInFavorites()
      }

      this.isPremium = await this.$store.dispatch('getPremiumStatusFromUser', this.$route.params.id)
    },
    currentUserFavorites: 'checkIfProfileIsInFavorites'
  },
  async mounted () {
    const id = this.$route.params.id

    await this.getProfile(id)
    if (this.currentUser && this.currentUser.uid) {
      await this.$store.dispatch('fetchFavoriteProfessionals')

      this.checkIfProfileIsInFavorites()
    }

    this.isPremium = await this.$store.dispatch('getPremiumStatusFromUser', this.$route.params.id)
  }
}

/**
 * @todo Remover profissional do perfil atual da lista de profissionais próximos e similares
 */
</script>
